var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.dataLogo,"alt":"logo","loading":_vm.lazy ? 'lazy' : null,"onerror":("this.src=\"" + _vm.DEFAULT_STOCK_LOGO + "\"")},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }